import { Emoji as EmojiMartEmoji } from '@emoji-mart/data';

export function Emoji({ emoji, size = 16 }: { emoji: EmojiMartEmoji; size?: number }) {
  return (
    <span style={{ width: size, height: size, lineHeight: `${size}px`, fontSize: size }}>
      {emoji.skins[0].native}
    </span>
  );
}
